import React from 'react';
import './UsageProgressBar.css';

interface UsageProgressBarProps {
    totalCapacity?: number;
    usedCapacity?: number;
    title?: string;
    unit?: string;
    style?: React.CSSProperties; // Add the style prop
}

const UsageProgressBar: React.FC<UsageProgressBarProps> = ({
    totalCapacity,
    usedCapacity,
    title,
    unit = '',
    style // Destructure style here
}) => {
    if (totalCapacity === undefined || usedCapacity === undefined) {
        return <div className="no-data-message">No Data</div>;
    }

    const usedPercentage = (usedCapacity / totalCapacity) * 100;
    const remainingPercentage = 100 - usedPercentage;

    return (
        <div className="progress-bar-container" style={style}> {/* Apply style prop here */}
            <div className="progress-bar-title">
                {title} ({remainingPercentage.toFixed(1)}% {unit} available)
            </div>
            <div className="progress-bar-background">
                <div className="progress-bar-fill" style={{ width: `${usedPercentage}%` }}></div>
            </div>
            <div className="progress-bar-label">
                {usedCapacity} {unit} used, {totalCapacity - usedCapacity} {unit} available
            </div>
        </div>
    );
};

export default UsageProgressBar;
